export const CONTACT_CUSTOM_ATTRIBUTE_PREFIX = 'contact_custom_attribute';
export const CONVERSATION_CUSTOM_ATTRIBUTE_PREFIX =
  'conversation_custom_attribute';
export const CONTACT_CUSTOM_ATTRIBUTE_VARIABLETYPE = 'contactCustomAttribute';
export const CONVERSATION_CUSTOM_ATTRIBUTE_VARIABLETYPE =
  'conversationCustomAttribute';
